module.exports = __webpack_public_path__ + "img/aiIcon-tts.e514a8ce.svg";